import { ParentTypeEnum } from '@/gen/cortado/v1/settings_pb'
import { extractTemplateVariables } from '@/lib/template-variable-tokens'

export const PORTAL_URL_TEMPLATE_VARIABLE = '{{ .portal.url }}'

export function supportsPortalURLTemplateVariable(parentType: ParentTypeEnum): boolean {
  return parentType === ParentTypeEnum.PARENT_TYPE_INQUIRY || parentType === ParentTypeEnum.PARENT_TYPE_BOOKING
}

/**
 * Portal URLs are deliberately unresolved in the editor: the backend mints a
 * fresh tracked credential only when an inquiry/booking email is sent. Every
 * other token remains a blocking unresolved variable.
 */
export function unresolvedComposeTemplateVariables(text: string, parentType: ParentTypeEnum): string[] {
  const variables = extractTemplateVariables(text)
  if (!supportsPortalURLTemplateVariable(parentType)) return variables
  return variables.filter((variable) => variable !== PORTAL_URL_TEMPLATE_VARIABLE)
}
